import React from "react";
import { useSelector } from "react-redux";
import { ThemeType } from "../../../../../redux/constants";
import { selectThemeSettings } from "../../../../../redux/slices/cmsSettingsSlice";
import { selectExistingRegistrations } from "../../../../../redux/slices/existingRegistrationsSlice";
import { selectRegistrationsFromRegistration } from "../../../../../redux/slices/registrationSlice";
import { selectSpecificFormSetting } from "../../../../../redux/slices/formSettingsSlice";
import { selectIsCms } from "../../../../../redux/slices/configSlice";
import MobileRegistrationSummary from "./MobileRegistrationSummary";

const ConnectedMobileRegistrationSummary = () => {
    const themeSettings = useSelector((state) =>
        selectThemeSettings(ThemeType.SUMMARY, state),
    );
    const {
        p2pGeneral: { summaryHeading = "Your Summary" },
        p2pPromo: { mobileAddPromoCodeLabel = "Add Promo Code" },
    } = themeSettings;
    const existingRegistrations = useSelector(selectExistingRegistrations);
    const registrations = useSelector(selectRegistrationsFromRegistration);
    const hasActivePromos = useSelector((state) =>
        selectSpecificFormSetting(state, "hasActivePromos"),
    );
    const isCms = useSelector(selectIsCms);

    // Check for existing registrations data
    const hasExistingRegistrations =
        Object.keys(existingRegistrations[0]).length > 0;
    // Check if any registrations have not been confirmed/saved by the UI
    const hasUnconfirmedRegistrations = registrations
        // Grab the special `Needs_To_Be_Reviewed` flag from each registration.
        // If it doesn't exist, give it a default value of `true`.
        .map(({ Needs_To_Be_Reviewed = true }) => Needs_To_Be_Reviewed)
        // If any of the `Needs_To_Be_Reviewed` values are `true`,
        // we have at least one unconfirmed registration.
        .some((bool) => bool === true);
    const displayUnconfirmedRegistrationsError =
        hasExistingRegistrations && hasUnconfirmedRegistrations;

    // Determine whether Promo prompt should display, matches conditions for Promo UI
    const primaryRegistration = registrations[0];

    const displayPromoCodePrompt =
        (isCms && hasActivePromos) ||
        (!isCms &&
            hasActivePromos &&
            Object.keys(primaryRegistration).length > 0 &&
            primaryRegistration.Category?.length > 0);

    const mobileRegistrationSummaryProps = {
        displayPromoCodePrompt,
        displayUnconfirmedRegistrationsError,
        summaryHeading,
        mobileAddPromoCodeLabel,
    };

    return <MobileRegistrationSummary {...mobileRegistrationSummaryProps} />;
};

export default ConnectedMobileRegistrationSummary;
